import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api, FalhaApi } from "../api";

export function Cadastro() {
  const [nomeFamilia, setNomeFamilia] = useState("");
  const [nomeAdmin, setNomeAdmin] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [concluido, setConcluido] = useState(false);

  async function aoEnviar(evento: FormEvent) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await api.cadastrar(nomeFamilia, nomeAdmin, email, senha);
      setConcluido(true);
    } catch (e) {
      setErro(
        e instanceof FalhaApi
          ? e.message
          : "Não foi possível conectar ao servidor. Verifique sua internet."
      );
    } finally {
      setEnviando(false);
    }
  }

  if (concluido) {
    return (
      <div className="tela-login">
        <div className="cartao cartao-login">
          <h1 className="marca">
            Lembr<span>Ai</span>
          </h1>
          <p>
            Cadastro criado! Enviamos um link de confirmação para <strong>{email}</strong>. Clique
            nele para ativar a conta e entrar.
          </p>
          <p className="rodape-login">
            <Link to="/entrar">Voltar para o login</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="tela-login">
      <form className="cartao cartao-login" onSubmit={aoEnviar}>
        <h1 className="marca">
          Lembr<span>Ai</span>
        </h1>
        <p className="subtitulo">Criar conta da família</p>

        {erro && (
          <div className="alerta alerta-erro" role="alert">
            {erro}
          </div>
        )}

        <label htmlFor="nomeFamilia">Nome da família</label>
        <input
          id="nomeFamilia"
          type="text"
          value={nomeFamilia}
          onChange={(e) => setNomeFamilia(e.target.value)}
          placeholder="ex.: Família Silva"
          required
        />

        <label htmlFor="nomeAdmin">Seu nome</label>
        <input
          id="nomeAdmin"
          type="text"
          value={nomeAdmin}
          onChange={(e) => setNomeAdmin(e.target.value)}
          autoComplete="name"
          required
        />

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          autoComplete="new-password"
          minLength={10}
          required
        />
        <p className="dica-campo">Mínimo de 10 caracteres.</p>

        <button className="botao botao-primario" type="submit" disabled={enviando}>
          {enviando ? "Criando conta…" : "Criar conta"}
        </button>

        <p className="rodape-login">
          Já tem conta? <Link to="/entrar">Entrar</Link>
        </p>
      </form>
    </div>
  );
}
